export default "__VITE_ASSET__cdcf5bf4__"